const AUTHENTICATED_ENTRY = "mark-authenticated";
const BACK_GUARD_ENTRY = "mark-authenticated-back-guard";

/** Keep browser/PWA Back inside the authenticated app.
 *
 * Mark V0 has no URL-routed in-app screens. Once the cookie session is proven,
 * older entries are exclusively the launch/AuthKit/callback journey and must not
 * become an accidental sign-out path. Explicit Settings > Sign out remains the
 * only operation that clears the server cookie.
 */
export function installAuthenticatedBackGuard(
  history: History = window.history,
  location: Location = window.location,
): () => void {
  const url = `${location.pathname}${location.search}${location.hash}`;
  history.replaceState({ ...(history.state ?? {}), mark: AUTHENTICATED_ENTRY }, "", url);
  history.pushState({ mark: BACK_GUARD_ENTRY }, "", url);

  const keepInsideApp = () => {
    history.pushState({ mark: BACK_GUARD_ENTRY }, "", url);
  };
  window.addEventListener("popstate", keepInsideApp);
  return () => window.removeEventListener("popstate", keepInsideApp);
}

export function isIosOutsideStandalone(
  navigatorValue: Navigator = navigator,
  matchMediaValue: (query: string) => Pick<MediaQueryList, "matches"> =
    typeof window.matchMedia === "function"
      ? window.matchMedia.bind(window)
      : () => ({ matches: false }),
): boolean {
  const ios = /iPad|iPhone|iPod/.test(navigatorValue.userAgent) ||
    (navigatorValue.platform === "MacIntel" && navigatorValue.maxTouchPoints > 1);
  const legacyStandalone = (navigatorValue as Navigator & { standalone?: boolean }).standalone;
  return ios && legacyStandalone !== true && !matchMediaValue("(display-mode: standalone)").matches;
}
